import React from 'react';
import styled from '@emotion/styled';

import { __ } from './helpers';

const Container = styled('div')``;

export default () => <Container>{__('Send to email as PDF')}</Container>;
